import { boolFilter, concatFilter, dateFilter, emptyFilter, numberFilter, truncateFilter, ucFirstFilter, upperCaseFilter, FilterPlugin } from "@wittignl/js-core";

import di from 'di';
export default function(app){

    const plugin = new FilterPlugin();

    plugin

        // Core
        .filter('bool', boolFilter)
        .filter('concat', concatFilter)
        .filter('date', dateFilter)
        .filter('empty', emptyFilter)
        .filter('number', numberFilter)
        .filter('truncate', truncateFilter)
        .filter('ucFirst', ucFirstFilter)
        .filter('upperCase', upperCaseFilter)

    app.use(plugin, {
        i18n: di.get('i18n')
    });
}